export const notificationSuccessMessage = {
  customerCharges: 'Customer charges updated',
  merchantInfo: 'Merchant information updated',
  merchantKyc: 'Merchant KYC information updated',
  storeInfo: 'Store information updated',
  clickCollect: 'Click and collect updated',
  staffAddUpdate: 'Staff updated',
  staffRemove: 'Staff member removed',
  stockCSVImport: 'Stock information updated with import data',
  themeUpdated: 'White labelling theme saved',
  addonItemRemove: 'Selected add-on items removed',
  stockItemRemove: 'Selected inventory items removed',
  printingConfigUpdated: 'Printing settings saved',
  storeInformationUpdated: 'Store information updated',
};

export const notificationFailureMessage = {
  formSubmission: 'There has been a problem.  Please try again',
  apiError: 'Something went wrong.  Please try again',
  stockCSVImport: 'Stock import went wrong.  Please try again',
  stockItemSave: 'Failed to save stock item',
  categorySave: 'Failed to save category',
  storeNotLoaded: 'Store information has not loaded, so the changes could not be saved. Please refresh the page and try again',
  noStore: 'No store is set up for this merchant account, so the changes could not be saved. Please contact Kody support',
  invalidFields: (fields: string[]): string => `Please check the following fields before saving: ${fields.join(', ')}`,
};

// Error messages that explain why a save failed need longer than the default duration to be read
export const errorReasonNotificationDuration = 8000;
